import { Lang } from '../lang';

export enum UserRole {
    GUEST = 'Invitada',
    PROCESSOR = 'Tramitador',
    ADVANCED_PROCESSOR = 'TramitadorAvanzado',
    MANAGER = 'Responsable',
    DIRECTOR = 'Director',
    NULL = ''
}

export interface UserState {
    id: string;
    name: string;
    preferedLang: Lang;
    role: string;
    preferedDepartamentId: number;
    application?: string;
}

export const initialUserState: UserState = {
    id: '',
    name: '',
    preferedLang: Lang.Spanish,
    role: UserRole.NULL,
    preferedDepartamentId: 0,
    application: ''
};
